export default class DtoPiezometrySituation {
    constructor(obj) {
        this.piezometryId = obj.piezometryId
        this.measures = obj.measures
    }
}